module.exports = "/assets/delice-page/bottle_2@2x.jpg?Aez3WxS";